import Hero from "../designSystem/Hero";
import SEO from "../designSystem/SEO";
import ResidentialImage from "../../assets/images/ourservices_residentialmortgages.png";
import BuyToLetImage from "../../assets/images/ourservices_buytoletmortgages.png";
import SpecialistImage from "../../assets/images/ourservices_specialistlending.png";
import ProtectionImage from "../../assets/images/ourservices_protection.png";
import HeroImage from "../../assets/images/ourservices_banner.png";
import PrimaryButton from "../designSystem/buttons/PrimaryButton";
import { ReactComponent as ResidentialIcon } from "../../assets/icons/residential_mortgages.svg";
import { ReactComponent as BuyToLetIcon } from "../../assets/icons/buy_to_let_mortgages.svg";
import { ReactComponent as SpecialistIcon } from "../../assets/icons/specialist_mortgages.svg";
import { ReactComponent as ProtectionIcon } from "../../assets/icons/protection.svg";

const services = [
  {
    id: "residential-mortgages",
    // eyebrow: "Residential Mortgages",
    title: "Residential Mortgages",
    image: ResidentialImage,
    icon: ResidentialIcon,
    imageAlt: "Modern residential homes financed with mortgage advice from TAG Mortgages",
    background: "bg-white",
    highlightBackground: "bg-gray-3",
    reverse: false,
    paragraphs: [
      "A residential mortgage allows you to purchase a property that will become your main home. Whether you're taking your first step onto the property ladder, moving to a new home or purchasing your forever property, choosing the right mortgage is an important financial decision.",
      "With thousands of mortgage products available across the market, finding the most suitable lender and mortgage can be time-consuming and confusing. At TAG Mortgages, we make the process simple.",
      "Our advisers take the time to understand your financial circumstances, future plans and borrowing requirements before recommending a mortgage that suits your needs. We compare a wide range of lenders and products to help secure a competitive solution tailored to you.",
      "From application to completion, we'll manage the process on your behalf, liaise with your lender and solicitor, and keep you updated throughout, making your mortgage journey as smooth and stress-free as possible.",
    ],
    note: "Your home may be repossessed if you do not keep up repayments on your mortgage.",
    importNote:
      "Our priority is helping you secure the right mortgage while making the entire experience straightforward and hassle-free.",
    highlights: [
      {
        title: "Personalised Advice",
        text: "Mortgage advice tailored to first-time buyers, home movers, remortgage clients and those with more complex borrowing requirements.",
      },
      {
        title: "Access to 90+ UK Lenders",
        text: "We compare mortgages from a broad panel of high street banks, specialist lenders and private banks to find a suitable solution.",
      },
      {
        title: "Dedicated Support",
        text: "We'll guide you through every stage of the mortgage process, handling the paperwork and communicating with everyone involved until your mortgage completes.",
      },
    ],
  },
  {
    id: "buy-to-let-mortgages",
    // eyebrow: "Buy-to-Let Mortgages",
    title: "Buy-to-Let Mortgages",
    image: BuyToLetImage,
    icon: BuyToLetIcon,
    imageAlt: "Buy-to-let apartment buildings for property investors",
    background: "bg-gray-3",
    reverse: true,
    paragraphs: [
      "A buy-to-let mortgage is designed for purchasing property that will be rented out to tenants rather than occupied by the owner. Whether you're buying your first investment property or growing an existing portfolio, selecting the right mortgage can play an important role in maximising your investment returns.",
      "Buy-to-let lending often involves more specialist criteria than residential borrowing. Lenders may consider rental income projections, portfolio size, property type and your wider financial position when assessing an application.",
      "At TAG Mortgages, we work with first-time landlords, experienced investors and limited company landlords, helping clients access competitive buy-to-let mortgage solutions from a wide range of lenders.",
    ],
    highlights: [
      {
        title: "Tailored Investment Advice",
        text: "Guidance for first-time landlords, experienced investors and limited company buy-to-let applications.",
      },
      {
        title: "Access to Specialist Lenders",
        text: "With access to more than 90 UK lenders, including specialist buy-to-let providers and private banks, we can source suitable finance for a wide variety of investment strategies.",
      },
      {
        title: "Complete Mortgage Support",
        text: "We'll handle the application process, liaise with lenders and keep everything progressing from enquiry through to completion.",
      },
    ],
    note: "Your home may be repossessed if you do not keep up repayments on your mortgage.",
    importNote:
      "Our aim is to make arranging your investment finance simple while helping you find the most appropriate borrowing solution.",
  },
  {
    id: "specialist-lending",
    // eyebrow: "Specialist Lending",
    title: "Specialist Lending",
    image: SpecialistImage,
    icon: SpecialistIcon,
    imageAlt: "Adviser reviewing specialist mortgage lending options",
    background: "bg-white",
    highlightBackground: "bg-gray-3",
    reverse: false,
    paragraphs: [
      "Not every borrower fits traditional lending criteria. If your financial circumstances are more complex, specialist mortgage solutions may offer greater flexibility than standard high street lending.",
      "Whether you're self-employed, receive income from multiple sources, require a larger loan, are purchasing an unusual property or have unique financial circumstances, specialist lenders can often provide solutions where standard lenders cannot.",
      "At TAG Mortgages, we have extensive experience arranging mortgages for clients with more complex borrowing requirements. With access to specialist lenders and private banks across the UK, we'll search the market for a mortgage tailored to your circumstances.",
    ],
    note: "Your home may be repossessed if you do not keep up repayments on your mortgage.",
    importNote:
      "Our goal is to help secure the right specialist lending solution while making the experience as straightforward as possible.",
    highlights: [
      {
        title: "Specialist Mortgage Advice",
        text: "Support for self-employed applicants, high-net-worth individuals, contractors, company directors and borrowers with more complex income structures.",
      },
      {
        title: "Extensive Lender Access",
        text: "Access to specialist lenders and private banks offering flexible lending solutions for non-standard applications.",
      },
      {
        title: "Personal Support Throughout",
        text: "We'll manage your mortgage application from start to finish, providing clear communication and expert guidance throughout the process.",
      },
    ],
  },
  {
    id: "protection",
    // eyebrow: "Protection",
    title: "Protection",
    image: ProtectionImage,
    icon: ProtectionIcon,
    imageAlt: "Family discussing mortgage and income protection insurance",
    background: "bg-gray-3",
    reverse: true,
    paragraphs: [
      "Choosing the right mortgage is only one part of protecting your financial future. Having suitable personal and business protection in place can provide valuable peace of mind for you, your loved ones, and your business if life doesn't go to plan.",
      "Whether you're looking to protect your mortgage repayments, replace lost income, provide financial security for your family, or safeguard your business against the financial impact of illness, injury or death, we'll help you understand the available options and recommend cover that's appropriate for your circumstances.",
      "At TAG Mortgages, we provide personalised protection advice alongside our mortgage services, including life insurance, critical illness cover, income protection and business protection solutions.",
    ],
    note: "Your home may be repossessed if you do not keep up repayments on your mortgage.",
    importNote:
      "Our aim is to ensure your home, income, family and business are properly protected, giving you confidence that you're prepared for whatever the future may bring.",
    highlights: [
      {
        title: "Personalised Recommendations",
        text: "Advice tailored to your individual circumstances, budget and long-term financial goals.",
      },
      {
        title: "Access to Leading UK Insurers",
        text: "We work with a range of trusted insurance providers to help arrange suitable protection at competitive premiums.",
      },
      {
        title: "Ongoing Support",
        text: "We'll explain your options clearly, arrange your cover and remain available should your circumstances change in the future.",
      },
    ],
  },
];

const ServiceIcon = ({ icon: Icon }) => (
  <Icon style={{ width: 60, height: 60, flex: "0 0 auto" }} />
);

const ServicesPage = () => {
  const scrollToService = (serviceId) => {
    document.getElementById(serviceId)?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  return (
    <div>
      <SEO
        title="Our Mortgage Services"
        description="Explore residential, buy-to-let and specialist mortgage advice, plus tailored protection solutions from TAG Mortgages."
        path="/our-services"
      />

      <Hero
        title="Our Services"
        // subtitle="TAG Mortgages"
        backgroundImage={HeroImage}
        showContactButton={false}
      />

      <section className="background-container bg-gray-3">
        <div className="content-container">
          <div className="column gap-l align-center">
            <div className="body2 text-primary-2 uppercase">- OUR SERVICES</div>
            <h2 className="h4 text-primary-1 text-center">What We Offer</h2>
            <div className="column gap-m">
              <div className="content text-gray-1 text-center">
                At TAG Mortgages, we provide expert mortgage and protection
                advice designed around your individual circumstances. Whether
                you're buying your first home, moving house, remortgaging,
                investing in property or arranging specialist finance, our
                experienced advisers are here to help you secure the right
                solution.
              </div>
              <div className="content text-gray-1 text-center">
                With access to over 12,000 mortgage products from more than 90
                UK lenders, including leading high street banks, specialist
                lenders and private banks, we can source competitive mortgage
                options for straightforward and more complex borrowing
                requirements alike.
              </div>
              <div className="content text-gray-1 text-center">
                Our services include residential mortgages, buy-to-let
                mortgages, remortgages, specialist and high-value lending,
                together with a range of protection solutions to help safeguard
                you, your family and your financial future. From your first
                enquiry through to completion, we provide clear advice, personal
                support and a straightforward service every step of the way.
              </div>
            </div>
            <div className="body1 text-gray-1 text-center">
              Your home may be repossessed if you do not keep up repayments on
              your mortgage.
            </div>
            <div className="row-center row-wrap gap-l">
              {services.map((service) => (
                <button
                  type="button"
                  className="service-scroll-link content text-primary-1"
                  key={service.id}
                  onClick={() => scrollToService(service.id)}
                >
                  {service.title}
                </button>
              ))}
            </div>
            <PrimaryButton text="speak to an adviser" />
          </div>
        </div>
      </section>

      {services.map((service) => (
        <section
          id={service.id}
          className={`background-container ${service.background}`}
          key={service.id}
        >
          <div className="content-container">
            <div className="column gap-l">
              <div className="grid2 gap-xxxxl p-m">
                <div
                  className="column gap-l"
                  style={{ order: service.reverse ? 2 : 1 }}
                >
                  {/* <ServiceIcon icon={service.icon} /> */}
                  <div className="body2 text-primary-2 uppercase">
                    {service.eyebrow}
                  </div>
                  <h2 className="h4 text-primary-1">{service.title}</h2>
                  <div className="column gap-l">
                    {service.paragraphs.map((paragraph) => (
                      <div className="content text-gray-1" key={paragraph}>
                        {paragraph}
                      </div>
                    ))}
                  </div>
                  {service.note && (
                    <div className="body2 text-primary-1">{service.note}</div>
                  )}
                </div>
                <img
                  src={service.image}
                  alt={service.imageAlt}
                  className="hero-image"
                  style={{ order: service.reverse ? 1 : 2 }}
                />
              </div>

              <div className={`grid3 gap-m`}>
                {service.highlights.map((highlight) => (
                  <article
                    className={`column gap-l p-l all-radius-l ${
                      service.highlightBackground || "bg-white"
                    }`}
                    key={highlight.title}
                  >
                    <div className="subtitle-semibold text-primary-1">
                      {highlight.title}
                    </div>
                    <div className="content text-gray-1">{highlight.text}</div>
                  </article>
                ))}
              </div>
              <div className="content-semibold text-primary-1 text-center">
                {service.importNote}
              </div>
            </div>
          </div>
        </section>
      ))}

      <section className="background-container bg-primary-1">
        <div className="content-container">
          <div className="column gap-l">
            <h2 className="h4 text-white">How We Can Help</h2>

            <div className="row-flex-start grid2 gap-xxxxl">
              <ul className="content text-white column gap-s">
                <li>Life Insurance</li>
                <li>Critical Illness Cover</li>
                <li>Income Protection</li>
                <li>Family Income Benefit</li>
                <li>Buildings and Contents Insurance</li>
                <li>Mortgage Protection</li>
                <li>Business Protection</li>
              </ul>
              <div className="content text-white">
                Our advisers will explain your options in clear, straightforward
                language and help you put the right protection in place, giving
                you confidence that you and your family are financially
                protected for the future.
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="background-container bg-gray-3">
        <div className="content-container">
          <div className="column gap-l align-center">
            <div className="body2  text-primary-1 uppercase">
              - LET’S GET YOU MOVING
            </div>

            <h2 className="h4 text-primary-1">
              Whether you're buying your first home, moving house, remortgaging,
              investing in property or looking for expert mortgage and
              protection advice, the team at TAG Mortgages is here to help.
            </h2>
            <div className="content text-primary-1">
              We understand that every client has unique goals and
              circumstances, which is why we take the time to listen, answer
              your questions and provide clear, straightforward advice tailored
              to your needs. From your initial enquiry through to completion and
              beyond, you can rely on us for friendly, professional support
              every step of the way.
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServicesPage;
